import { useRef } from 'react';

import { getTimeSeriesPeriodMap } from '@/utilities/timeSeriesPeriodMap';

export const useUtcOffsetPeriodMap = () => {
  const { current: dateISOString } = useRef(new Date().toISOString());
  // The timezone is always zero UTC offset for CIQ data
  const today = dateISOString.slice(0, dateISOString.indexOf('T'));
  const { current: periodMap } = useRef(
    getTimeSeriesPeriodMap(new Date(today))
  );
  return periodMap;
};
